import { Box, Flex, Text, Heading } from "@chakra-ui/react";
import { Grid, GridItem } from "@chakra-ui/react";
import Session from "../components/Session";
import Sessions from "../data/Sessions";

interface ProgramProps {
  title: string;
  today: string;
}

export default function Program({ title, today }: ProgramProps) {
  return (
    <Box p={4} borderRadius="md" mb={4}>
      <Heading as="h2" size="lg" mb={12} color="blue.700" fontWeight="bold" whiteSpace="pre-line">
        {title}
      </Heading>
      {Sessions
        .filter((session) => session.day === today)
        .map((session) => (
          <Session
            id={session.id}
            title={session.title}
            content={session.content}
            day={session.day}
            link={session.link}
          ></Session>
        ))}
    </Box>
  );
}
